const bindHaloTopLanguageToggle = () => {
    if (window.__haloTopLanguageToggleBound) return;

    document.addEventListener('click', (event) => {
        const button = event.target.closest('.halo-top-language .disclosure__button');

        if (button) {
            const headerLanguageCurrency = button.closest('.header-language_currency');

            // Header dropdown is managed by theme.js; avoid double toggling there.
            if (headerLanguageCurrency) {
                return;
            }

            event.preventDefault();

            const haloTopLanguage = button.closest('.halo-top-language');
            const topLanguageCurrency = button.closest('.top-language-currency');
            const dropdownLanguage = haloTopLanguage?.querySelector('.dropdown-language');

            if (headerLanguageCurrency) {
                headerLanguageCurrency.querySelectorAll('.dropdown-language.show').forEach((element) => {
                    if (element !== dropdownLanguage) element.classList.remove('show');
                });
            }

            topLanguageCurrency?.classList.add('show');
            dropdownLanguage?.classList.toggle('show');
            return;
        }

        if (!event.target.closest('.header-language_currency')) {
            document.querySelectorAll('.header-language_currency .dropdown-language.show').forEach((element) => {
                element.classList.remove('show');
            });
        }
    });

    window.__haloTopLanguageToggleBound = true;
};

const bindHaloLanguageForceUrlClick = () => {
    if (window.__haloLanguageForceUrlBound) return;

    document.addEventListener('click', (event) => {
        const forceLink = event.target.closest('.halo-language a[data-force-url]');
        if (!forceLink) return;

        event.preventDefault();
        const targetUrl = forceLink.dataset.forceUrl;
        if (targetUrl) {
            window.location.href = targetUrl;
        }
    });

    window.__haloLanguageForceUrlBound = true;
};

if (typeof localizationForm === 'undefined') {

    class LocalizationForm extends HTMLElement {
        constructor() {
            super();
            this.elements = {
                input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
                returnToInput: this.querySelector('input[name="return_to"]'),
                button: this.querySelector('button'),
                panel: this.querySelector('ul'),
            };
            // this.elements.button.addEventListener('click', this.openSelector.bind(this));
            // this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
            this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    
            // document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
    
        }
    
        onItemClick(event) {
            event.preventDefault();

            const forcedUrl = event.currentTarget.dataset.forceUrl;
            if (forcedUrl) {
                window.location.href = forcedUrl;
                return;
            }

            this.elements.input.value = event.currentTarget.dataset.value;

            if (this.elements.returnToInput && event.currentTarget.dataset.returnTo) {
                this.elements.returnToInput.value = event.currentTarget.dataset.returnTo;
            }

            this.querySelector('form')?.submit();
        }
    
        openSelector() {
            this.elements.button.focus();
            this.elements.panel.toggleAttribute('hidden');
            this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
        }
    
        closeSelector(event) {
            const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
            if (event.relatedTarget === null || shouldClose) {
                this.elements.button.setAttribute('aria-expanded', 'false');
                this.elements.panel.setAttribute('hidden', true);
            }
        }
    
        onBodyClickEvent(event){
            if ((!this.contains(event.target)) && ($(event.target).closest('[localization-form__select]').length === 0)){
                this.closeSelector(event);
            }
        }
    }
    
    if (!customElements.get('localization-form')) {
        customElements.define('localization-form', LocalizationForm);
    }

    var localizationForm = LocalizationForm;
}

bindHaloTopLanguageToggle();
bindHaloLanguageForceUrlClick();